export function getPasswordStrength(password) {
  let strength = 0
  if (password.length >= 8) strength += 25
  if (/[A-Z]/.test(password)) strength += 25
  if (/[0-9]/.test(password)) strength += 25
  if (/[^A-Za-z0-9]/.test(password)) strength += 25
  return strength
}

export function getStrengthText(strength) {
  if (strength === 0) return ""
  if (strength <= 25) return "Weak"
  if (strength <= 50) return "Fair"
  if (strength <= 75) return "Good"
  return "Strong"
}

export function getStrengthColor(strength) {
  if (strength <= 25) return "bg-red-500"
  if (strength <= 50) return "bg-yellow-500"
  if (strength <= 75) return "bg-blue-500"
  return "bg-green-500"
}

/**
 * Generates a secure random password that meets all strength requirements
 * @param {number} length - Length of the password (default: 16)
 * @returns {string} Generated password
 */
export function generatePassword(length = 16) {
  const lowercase = "abcdefghijklmnopqrstuvwxyz"
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  const numbers = "0123456789"
  const special = "!@#$%^&*()_+-=[]{}|;:,.<>?"
  
  // Ensure at least one character from each category
  let password = ""
  password += lowercase[Math.floor(Math.random() * lowercase.length)]
  password += uppercase[Math.floor(Math.random() * uppercase.length)]
  password += numbers[Math.floor(Math.random() * numbers.length)]
  password += special[Math.floor(Math.random() * special.length)]
  
  // Fill the rest with random characters from all categories
  const allChars = lowercase + uppercase + numbers + special
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)]
  }
  
  // Shuffle the password to avoid predictable pattern
  return password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("")
}